import { render } from "./CompetitionList.vue?vue&type=template&id=2d073a42&scoped=true"
import script from "./CompetitionList.vue?vue&type=script&lang=js"
export * from "./CompetitionList.vue?vue&type=script&lang=js"

import "./CompetitionList.vue?vue&type=style&index=0&id=2d073a42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d073a42"]])

export default __exports__